import React from 'react'

export const MouseDownContext = React.createContext(false)
